import ClientUtils from './utils';

const environment = process.env.NWEA_ENV || 'team16';
const baseUrl = !__BATCH__ ? '/partnerConfig' : `https://pconf.${environment}.map2.nweacolo.pvt/partnerConfig`;

export default {
    getTermsForPartner: (partnerBid, callback, optionalFailureCallback = null) => {
        const url = `${baseUrl}/partners/${partnerBid}/terms`;
        return ClientUtils.makeGetRequest(url, callback, {}, optionalFailureCallback);
    },
    getSystemConfiguration: (partnerBid, callback) => {
        const url = `${baseUrl}/partners/${partnerBid}/systemConfigurations`;
        return ClientUtils.makeGetRequest(url, callback);
    },
    getAcademicYearForPartner: (partnerBid, callback, failureCallback) => {
        const url = `${baseUrl}/partners/${partnerBid}/currentAcademicYear`;
        if (!failureCallback) {
            failureCallback = (resp) => {
                console.log('failure getting current academic year............................', resp);
            };
        }
        return ClientUtils.makeGetRequest(url, callback, null, failureCallback);
    },
};
